import React, { useEffect, useState } from 'react';
import { get } from 'global/lib/lodash';
import { useSelector } from 'react-redux';

export default (Component) => (props) => {
  const currentRealm = useSelector((state) => get(state, 'auth.realm'));
  const [crealm, setcrealm] = useState(currentRealm);

  useEffect(() => {
    if (get(crealm, 'id') !== get(currentRealm, 'id')) {
      setcrealm(currentRealm);
      props.onRealmChange && props.onRealmChange(currentRealm);
    }
  }, [currentRealm]);

  return <Component {...props} />;
};
